import { defineComponent } from 'vue';
import { Stocks } from '@/components';
export default defineComponent({
    name: 'page-stocks',
    components: {
        Stocks: Stocks,
    },
});
